import React from 'react';

const CustomTabs2 = ({ tabs, activeTab }) => {
  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {tabs.map((tab) => (
          <span
            key={tab.label}
            className={`flex whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium 
                        hover:cursor-pointer hover:text-blue-700 
                        ${activeTab === tab.label ? 'border-blue-700 text-blue-700' : 'border-transparent text-gray-500'}`}
            onClick={tab.onClick}
          >
            {tab.label}
          </span>
        ))}
      </nav>
    </div>
  );
};

export default CustomTabs2;
